module.exports = __webpack_public_path__ + "static/media/comdlg32_536.82e583e6.ico";